// extracted by mini-css-extract-plugin
module.exports = {"topSection":"CharactersSpeciesDetail_topSection_eLAwI","bioBlock":"CharactersSpeciesDetail_bioBlock_2WS9C","bioTable":"CharactersSpeciesDetail_bioTable_1T0Rq"};